import { IS_VALID_SOCIAL_SECURITY } from "../actions/action-types";

export const isValidSocialSecurityReducer = (state = 0, action) => {
  if (action.type === IS_VALID_SOCIAL_SECURITY) {
    return action.data;
  }
  return state;
};
